module.exports = __webpack_public_path__ + "media/lateral spreading tumor.1aed112a.wav";